import { render } from "./LegalConfirmationModal.vue?vue&type=template&id=6b1b9bcd&scoped=true"
import script from "./LegalConfirmationModal.vue?vue&type=script&lang=js"
export * from "./LegalConfirmationModal.vue?vue&type=script&lang=js"

import "./LegalConfirmationModal.vue?vue&type=style&index=0&id=6b1b9bcd&lang=css"
import "./LegalConfirmationModal.vue?vue&type=style&index=1&id=6b1b9bcd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b1b9bcd"]])

export default __exports__